import React, { useState, useEffect } from 'react';
import './EmployeeSidebar.css';

// İkon bileşenleri
const ShiftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);

const CheckInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

const CashboxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2"></rect>
    <circle cx="12" cy="12" r="2"></circle>
    <path d="M6 12h.01M18 12h.01"></path>
  </svg>
);

const TodoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

// Hamburger menü ikonu
const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

// Kapatma ikonu (X)
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const EmployeeSidebar = ({ activeSection, setActiveSection, onLogout, employeeName }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile); // Mobilde kapalı, masaüstünde açık başla

  const menuItems = [
    { id: 'shifts', label: 'Mesai', icon: <ShiftIcon /> },
    { id: 'upload', label: 'Görsel Yükle', icon: <UploadIcon /> },
    { id: 'checkin', label: 'Check-in', icon: <CheckInIcon /> },
    { id: 'availability', label: 'Mesai Uygunluklarım', icon: <CashboxIcon /> },
    { id: 'todos', label: 'Yapılacaklar', icon: <TodoIcon /> }
  ];

  // Ekran genişliği değiştiğinde kontrol et
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Masaüstüne geçince sidebar'ı otomatik aç
      if (!mobile) {
        setSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Mobilde menü öğesine tıklayınca sidebar'ı kapat
  const handleMenuClick = (id) => {
    setActiveSection(id);
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <>
      {/* Mobil Toggle Button */}
      {isMobile && (
        <button 
          className="employee-sidebar-toggle-button"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label={sidebarOpen ? "Menüyü Kapat" : "Menüyü Aç"}
        >
          {sidebarOpen ? <CloseIcon /> : <HamburgerIcon />}
        </button>
      )}

      {/* Sidebar */}
      <div className={`employee-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="employee-sidebar-header">
          <h1>Kafe Panel</h1>
          <div className="employee-info">
            <span className="employee-name">{employeeName}</span>
          </div>
        </div>

        <nav className="employee-sidebar-menu">
          <ul>
            {menuItems.map(item => (
              <li 
                key={item.id}
                className={activeSection === item.id ? 'active' : ''}
                onClick={() => handleMenuClick(item.id)}
              >
                <span className="employee-sidebar-icon">{item.icon}</span>
                <span className="employee-sidebar-label">{item.label}</span>
              </li>
            ))}
          </ul>
        </nav>

        <div className="employee-sidebar-footer">
          <button className="employee-logout-button" onClick={onLogout}>
            <LogoutIcon />
            <span>Çıkış Yap</span>
          </button>
        </div>
      </div>
      
      {/* Mobil cihazlarda sidebar açıkken arka plan örtüsü */}
      {isMobile && sidebarOpen && (
        <div className="employee-sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>
      )}
    </>
  );
};

export default EmployeeSidebar;